<script setup>
import { ref, computed, defineEmits, onBeforeMount } from 'vue'

import FormFiltroPeriodo from '../components/FormFiltroPeriodo'
import FormFiltroSelecao from '../components/FormFiltroSelecao.vue'

const payloadPeriodo = ref()
const filtroPeriodo = ref()
const payloadSelecao = ref()
const request = ref(false)

const obterPayloadPeriodo = (value) => (payloadPeriodo.value = value)
const obterPayloadSelecao = (value) => (payloadSelecao.value = value)

const payloadFiltro = computed(() => {
  return {
    dataInicio: payloadPeriodo.value?.dataInicio,
    dataFim: payloadPeriodo.value?.dataFim,
    tipoSelecao: payloadSelecao.value?.tipoSelecao,
    matricula: payloadSelecao.value?.matricula,
    patios: payloadSelecao.value?.patios,
    cargos: payloadSelecao.value?.cargos,
    unidades: payloadSelecao.value?.unidades
  }
})

const emit = defineEmits(['enviarPayloadFiltro', 'enviarRequest'])

const enviarPayloadFiltro = () => {
  emit('enviarPayloadFiltro', payloadFiltro.value)
  request.value = !request.value
  emit('enviarRequest', request.value)
}

onBeforeMount(enviarPayloadFiltro)
</script>
<template>
  <div class="container-jornada-trabalho mb-6">
    <Progress :active="active" />
    <Panel header="Filtros" class="container" :toggleable="true">
      <FormFiltroPeriodo ref="filtroPeriodo" @payloadPeriodo="obterPayloadPeriodo" />
      <FormFiltroSelecao :idReferencia="filtroPeriodo?.referencia?.id" @payloadSelecao="obterPayloadSelecao" />
      <div class="button-filtro-jornada-trabalho">
        <Button label="Gerar Relatório" class="p-button" @click="enviarPayloadFiltro" :loading="active" />
      </div>
    </Panel>
  </div>
</template>
<style scoped>
.container-jornada-trabalho {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  flex-direction: column;
}
.button-filtro-jornada-trabalho {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
</style>
